// https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#managing-data-flow-with-the-integrations-object
// eslint-disable-next-line import/prefer-default-export
export const integrations = {
  All: false,
  'Google Analytics': true,
  'Segment.io': true,
  'LaunchDarkly Events': true,
  Mixpanel: true,
  Intercom: false,
};

export const serverIntegrations = {
  ...integrations,
  Intercom: true,
  'Marketo V2': true,
  Inflection: true,
};
